<template>
  <v-layout row justify-center>
    <v-dialog :value="value" max-width="305" persistent>
      <div class="loading-modal-content">
        <div class="loading-spinner-container">
          <div class="loading-spinner"></div>
          <v-icon class="material-icons-outlined loading-icon">{{
            icon
          }}</v-icon>
        </div>
        <div class="loading-text">{{ message }}</div>
      </div>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: "LoadingModal",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: "読み込み中..."
    },
    icon: {
      type: String,
      default: "import_contacts"
    }
  }
};
</script>

<style scoped>
.loading-modal-content {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 40px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
}

.loading-spinner-container {
  position: relative;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-spinner {
  position: absolute;
  width: 100.76px;
  height: 100.76px;
  top: -11.32px;
  left: -11.32px;
  border-radius: 40px;
  background-color: #eaf4f4;
  opacity: 1;
  animation: rotate 4s linear infinite;
}

.loading-icon {
  position: relative;
  font-size: 48px;
  color: #4cb5b8;
  z-index: 1;
}

.loading-text {
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  text-align: center;
  line-height: 1.5;
  white-space: pre-line;
}

@keyframes rotate {
  0% {
    transform: rotate(15deg);
  }
  100% {
    transform: rotate(375deg);
  }
}
</style>
